/**
 * {order}の送信設定（#233、docs/93 §4.3・Figma ①-3）を人ごとに覚える（この端末の localStorage。キーに人の番号を入れる）。
 *   ・「次回も同じ設定」がオンのあいだ、送信方法・印字項目を gb.order.sendPrefs.<人> に覚える。オフにすると消す
 *   ・承諾の方法（なし／電子／紙。#253）は覚えない＝発行の窓のその1回の値。初めの値はいつも{vendor}の承諾方法 → 会社の既定（Order.ack.initial）
 *     （前に覚えていた eAck は読まない）
 *   ・リンクで送るのは電子のときだけ（電子でなければ初めの送信方法は印刷・FAX）
 *   ・読み書きに失敗しても（プライベートの窓・保存の無効）画面はふつうに動く＝既定の形
 */
import type { Order } from "@genbaryoku/contract";

export type OrderSendPrefs = {
  via: "print" | "mail" | "link";
  printBreakdown: boolean;
  printSeal: boolean;
  remember: boolean;
};
const KEY = "gb.order.sendPrefs.";

export function loadSendPrefs(account: string, o: Pick<Order, "ack" | "print">): OrderSendPrefs {
  const electronic = o.ack.initial === "electronic";
  const base: OrderSendPrefs = { via: electronic ? "link" : "print", printBreakdown: o.print.breakdown, printSeal: o.print.seal, remember: false };
  try {
    const raw = account ? window.localStorage.getItem(KEY + account) : null;
    if (!raw) return base;
    const v = JSON.parse(raw) as Partial<OrderSendPrefs>;
    const via = v.via === "mail" || v.via === "link" || v.via === "print" ? v.via : base.via;
    return {
      // リンクは電子のときだけ
      via: via === "link" && !electronic ? "print" : via,
      printBreakdown: typeof v.printBreakdown === "boolean" ? v.printBreakdown : base.printBreakdown,
      printSeal: typeof v.printSeal === "boolean" ? v.printSeal : base.printSeal,
      remember: true,
    };
  } catch {
    return base;
  }
}
export function saveSendPrefs(account: string, p: OrderSendPrefs): void {
  if (!account) return;
  try {
    if (p.remember) window.localStorage.setItem(KEY + account, JSON.stringify({ via: p.via, printBreakdown: p.printBreakdown, printSeal: p.printSeal, remember: true }));
    else window.localStorage.removeItem(KEY + account);
  } catch {
    /* 覚えられなくても画面は動く */
  }
}
